import { Modal, Table, Badge } from "react-bootstrap";
import currency from "currency.js";
import { useCurrencies } from "../../utils/hooks";

function money(value, symbol) {
  if (value === null || value === undefined || value === "") return "—";
  return currency(value, { symbol, precision: 2 }).format();
}

export default function CostIncentiveDetailModal({ show, onHide, batch }) {
  const { prevailingCurrencySymbol } = useCurrencies();

  const incentiveTypes = batch?.incentiveTypes || [];
  const totalIncentivePerBag = incentiveTypes.reduce(
    (sum, el) => currency(sum).add(el.ratePerBag || 0).value,
    0
  );

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cost &amp; Incentive Detail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          <b>ATC Code:</b> {batch?.ATC_Code || batch?.InvoiceNo || "—"}
          <br />
          <b>Item:</b> {batch?.ItemName || "—"}
          <br />
          <b>Manufacturer:</b> {batch?.manufacturer || "—"}
        </p>

        <Table borderless size="sm" className="mb-3">
          <tbody>
            <tr>
              <td>Purchase Price</td>
              <td className="text-end">
                {money(batch?.purchasePrice, prevailingCurrencySymbol)}
              </td>
            </tr>
            <tr>
              <td>Incentive (per bag)</td>
              <td className="text-end">
                {money(totalIncentivePerBag, prevailingCurrencySymbol)}
              </td>
            </tr>
          </tbody>
        </Table>

        {incentiveTypes.length > 0 ? (
          <Table size="sm" responsive className="mb-3">
            <thead>
              <tr>
                <th>Incentive Type</th>
                <th>Category</th>
                <th className="text-end">Rate/Bag</th>
                <th className="text-end">Amount Due</th>
              </tr>
            </thead>
            <tbody>
              {incentiveTypes.map((el, index) => (
                <tr key={index}>
                  <td>{el.name || "—"}</td>
                  <td>{el.category || "—"}</td>
                  <td className="text-end">
                    {money(el.ratePerBag, prevailingCurrencySymbol)}
                  </td>
                  <td className="text-end">
                    {money(el.amountDue, prevailingCurrencySymbol)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="text-muted mb-3">No incentive assigned yet.</p>
        )}

        <Table borderless size="sm" className="mb-0">
          <tbody>
            <tr>
              <td>
                Adjusted / Effective Cost Price{" "}
                <Badge bg="secondary">Internal</Badge>
              </td>
              <td className="text-end">
                {money(batch?.effectiveCost, prevailingCurrencySymbol)}
              </td>
            </tr>
            <tr>
              <td>Selling Price</td>
              <td className="text-end">
                {money(batch?.UnitPrice, prevailingCurrencySymbol)}
              </td>
            </tr>
            <tr>
              <td>
                Margin <Badge bg="secondary">Internal</Badge>
              </td>
              <td className="text-end">
                {money(batch?.margin, prevailingCurrencySymbol)}
                {batch?.marginPercent != null
                  ? ` (${currency(batch.marginPercent, {
                      symbol: "",
                      precision: 1,
                    }).format()}%)`
                  : ""}
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
}
